import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Collapse, Form, Select, DatePicker, Button, Badge } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all } from '../../services/restApi'
import { getTotal, createPassword } from '../../utils'
import PaymentNew from './incomeNew'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;
const ButtonGroup = Button.Group;

class Payment extends Component {

	constructor (props) {
        super(props);

        this.state = {
        	query: {},
            hotels: [],
            incomes: [],
            NewIncomeVisible: false,
            newIncomeProps: {incomeType: 'payments'},
            skip: 0,
            limit: 1000
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/incomes/payments/hotel')
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Consulta los hoteles
        all('Hotel', {limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })

        // Consulta el total del mes anterior
        this.getPreviousTotal();
    }


    /**
    * Se llama antes del render()
    */
    componentWillMount () {
        this.props.dispatch({type:'income/filterSuccess', 
            payload: { incomes: [] }
        });

        this.firstLoad();
    }



    /**
    * Agrupamos: Cada registro por fecha de creación
    */
    groupByDate (array, count) {

        let incomesGrouped = _.groupBy(array, function (d) { return moment(d.requestedAt.iso).format('YYYY-MM-DD') });
        let incomesCaja = _.filter(array, function (i) { return i.chargedTo === 'caja' || !i.chargedTo });
        let incomesOwner = _.filter(array, { chargedTo: 'propietario' });
        let incomesTrie = _.filter(array, { chargedTo: 'trie' });

        Object.keys(incomesGrouped).map((key, index) => {

            let item = {};
            item.requestedAt = {__type: 'Date', iso: key};
            item.isParent =  true;
            item.children =  incomesGrouped[key];
            item.objectId = createPassword();
            item.amount_income_total = getTotal(incomesGrouped[key], 'amount_income');
            item.amount_expense_total = getTotal(incomesGrouped[key], 'amount_expense');
            item.children.map((i) => { i.parentId = item.objectId });

            this.state.incomes.push(item);

            if (index === Object.keys(incomesGrouped).length - 1) {
                let total = getTotal(this.state.incomes, 'amount_income_total') - getTotal(this.state.incomes, 'amount_expense_total')
                let totalCaja = getTotal(incomesCaja, 'amount_income') - getTotal(incomesCaja, 'amount_expense');
                let totalOwner = getTotal(incomesOwner, 'amount_income') - getTotal(incomesOwner, 'amount_expense');
                let totalTrie = getTotal(incomesTrie, 'amount_income') - getTotal(incomesTrie, 'amount_expense');

                this.setState({ currentTotal: total, totalCaja: totalCaja, totalOwner: totalOwner, totalTrie: totalTrie });

                setTimeout(function() {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                }.bind(this), 500);
            }
        });
    }


    /**
    * Consulta el reporte anterior para saber el saldo
    */
    getPreviousTotal () {
        this.props.form.validateFieldsAndScroll((errors, values) => {
            // Query
            let query = {type: 'payments'};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            if (values.custom_date) {
                query.requestedAt = {
                    $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            } else {
                query.requestedAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            }

            all('Income', {
                where: query,
                skip: 0, 
                limit: 1000, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                if (resp.results.length > 0) {

                    let previousTotal = getTotal(resp.results, 'amount_income') - getTotal(resp.results, 'amount_expense');
                    this.setState({ previousTotal: previousTotal });
                } else {
                    this.setState({ previousTotal: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        });
    }


    setTotals (array) {
        let incomesCaja = _.filter(array, function (i) { return i.chargedTo === 'caja' || !i.chargedTo });
        let incomesOwner = _.filter(array, { chargedTo: 'propietario' });
        let incomesTrie = _.filter(array, { chargedTo: 'trie' });

        let total = getTotal(array, 'amount_income') - getTotal(array, 'amount_expense')
        let totalCaja = getTotal(incomesCaja, 'amount_income') - getTotal(incomesCaja, 'amount_expense');
        let totalOwner = getTotal(incomesOwner, 'amount_income') - getTotal(incomesOwner, 'amount_expense');
        let totalTrie = getTotal(incomesTrie, 'amount_income') - getTotal(incomesTrie, 'amount_expense');

        this.setState({ currentTotal: total, totalCaja: totalCaja, totalOwner: totalOwner, totalTrie: totalTrie });
    }


    /**
    * Primera carga
    */
    firstLoad () {
        let query = {type: 'payments'};
        query.requestedAt = {
            $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
            $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
        };

        if (this.state.currentHotel) {
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
        }

        this.setState({query: query});
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('Income', {
            where: query,
            include: 'hotel,payment,createdBy', 
            skip: 0, 
            limit: this.state.limit, 
            count: 1, 
            order: 'requestedAt'
        }).then(resp => {

            this.props.dispatch({type: 'app/hideLoadingTable'})
            /*this.setState({ skip: this.state.limit, total_items: resp.count });

            if (resp.results.length > 0)
                this.groupByDate(resp.results, resp.count)
            else
                this.props.dispatch({type: 'app/hideLoadingTable'});*/

            if (resp.results.length > 0) {

                this.setTotals(resp.results);
                this.setState({ incomes: resp.results });

                this.props.dispatch({type:'income/querySuccess', 
                    payload: { incomes: this.state.incomes }
                });
            }

        }).catch(e => {
            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error al consultar los registros. Intente más tarde')    
        });
    }


	/**
	* Carga otro bloque de registros
	*/
    loadMore () {
    	if (this.state.skip < this.state.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})
            this.setState({ skip: this.state.skip + this.state.limit });

            all('Income', {
                where: this.state.query,
                include: 'hotel,payment,createdBy', 
                skip: this.props.income.skip, 
                limit: this.props.income.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                this.props.dispatch({type: 'app/hideLoadingTable'})
                /*this.props.dispatch({type:'income/filterSuccess', 
                    payload: { incomes: [] }
                });

                if (resp.results.length > 0)
                    this.groupByDate(resp.results, resp.count)
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})*/

                if (resp.results.length > 0) {
                    let array = this.state.incomes;
                    
                    this.setTotals(resp.results);
                    this.setState({ incomes: array.concat(resp.results) });

                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error al consultar otros registros. Intente más tarde')    
            });
    	}
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


  	/**
    * Búsqueda
    */
    search (notReload) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query;
            notReload ? query = this.state.query : query = {type: 'payments'};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            if (values.custom_date) {
                query.requestedAt ={
                    $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).endOf('month').format()).toISOString()},
                }

            } else {
                query.requestedAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
                };
            }


            this.setState({query: query});

            all('Income', {
                where: query,
                include: 'hotel,payment,createdBy', 
                skip: 0, 
                limit: this.state.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {
                
                this.props.dispatch({type: 'app/hideLoadingTable'})
                this.setState({incomes: [], skip: this.state.limit, total_items: resp.count});

                this.getPreviousTotal();
                this.props.dispatch({type:'income/filterSuccess', 
                    payload: { incomes: [] }
                });

                /*if (resp.results.length > 0)
                    this.groupByDate(resp.results, resp.count);
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})*/

                if (resp.results.length > 0) {

                    this.setTotals(resp.results);
                    this.setState({ incomes: resp.results });

                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                } else {
                    this.setState({ totalOwner: 0, totalTrie: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        
        let dispatch = this.props.dispatch;
        let currentTotal = this.state.currentTotal;
        let currentState = this;

        confirm({
            title: '¿Estás seguro que deseas eliminar el registro?',
            onOk () {
                dispatch({type: 'income/removeItem', payload: item});

                setTimeout(function() {
                    currentState.setTotals(currentState.props.income.incomes);
                }, 1000);
            }
        })
    }


    /**
    * Establece el acción para editar
    */
    setUpdate (item) {
        this.setState({ 
            newIncomeProps: {
                incomeId: item.objectId, 
                parentId: item.parentId, 
                incomeType: 'payments'
            }
        });
        this.showModalNewIncome();
    }


    /**
    * Establece el acción para crear
    */
    setCreate (item) {
        this.setState({ newIncomeProps: {incomeType: 'payments'} });
        this.showModalNewIncome();
    }


    /**
    * Actualiza el registro como gasto pagado
    */
    incomePaidout (item) {

        // Model
        let data = {};
        data.objectId = item.objectId;
        data.type = 'payments';
        data.status = 'paidout';
        data.parentId = item.parentId;

        this.props.dispatch({type: 'income/update', payload: data});
    }


    /**
    * Muestra / Oculta el modal para nuevo ingreso
    */
    showModalNewIncome () { this.setState({ NewIncomeVisible: true }); }
    hideModalNewIncome () { 
        //this.props.form.resetFields();
        //this.setState({ NewIncomeVisible: false, incomes: [] }); 
        this.setState({ NewIncomeVisible: false }); 
        /*this.props.dispatch({type:'income/filterSuccess', 
            payload: {
                incomes: [], 
                skip: this.state.limit, 
                total_items: 0
            }
        });*/
        this.search(true); 
    }


  	/**
    * Render del componente
    */
    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
                        <Link onClick={() => window.history.back() }><i className="fa fa-arrow-circle-left"></i></Link>
                        Pagos y depósitos&nbsp;
                        <Button type='primary' className="pull-right">
                            <Link onClick={this.setCreate.bind(this)} className=""><Icon name="plus" /> Agregar nuevo registro</Link>
                        </Button>
                    </h1>
	            </section>

	            <section className="content">

	            	<Collapse defaultActiveKey={['1']} className="marginBottom20">
					    <Panel header="Filtros" key="1">
					      	<Form>
                                <div className="row">
                                    {/*!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    */}

                                    <div className="col-md-3">
                                        <FormItem label="Mes" hasFeedback>
                                            {this.props.form.getFieldDecorator('custom_date', {
                                                initialValue: moment(new Date, 'YYYY-MM')
                                            })(
                                                <MonthPicker placeholder="Seleccione el mes" />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3" style={{marginTop: 40}}>
                                        <Button type='primary' onClick={() => this.search()} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                            <Icon name="filter" /> Consultar
                                        </Button>
                                    </div>
                                </div>
		                    </Form>
					    </Panel>
					</Collapse>

	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                        <div className="box-header with-border">
                            <span className="badge bg-pink">{this.state.currentHotel.chief}:</span> <Currency quantity={this.state.totalOwner ? this.state.totalOwner : 0} currency="USD" /> &nbsp;&nbsp;&nbsp;&nbsp;
                            <span className="badge bg-light-green">TRIE:</span> <Currency quantity={this.state.totalTrie ? this.state.totalTrie : 0} currency="USD" /> &nbsp;&nbsp;&nbsp;&nbsp;
                            <Icon name="angle-double-right" /> &nbsp;&nbsp;&nbsp;&nbsp;
                            <span className="badge bg-blue">Total:</span> <Currency quantity={this.state.totalCaja || this.state.totalTrie || this.state.totalOwner ? this.state.totalCaja + this.state.totalTrie + this.state.totalOwner : 0} currency="USD" />
                        </div>

	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.income.incomes} 
		                                    	rowKey="objectId" 
		                                    	size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>

		                                    	<Column title="Status" key="status" width={135} render={(item) => (
                                                    <span>
                                                        {!item.isParent && !item.status || item.status === 'pending' 
                                                            ? <span><Badge status="warning" /><small>Pendiente</small></span>
                                                            : ''
                                                        }
                                                        {!item.isParent && item.status === 'paidout' 
                                                            ? <span><Badge status="success" /><small>Pagado</small></span>
                                                            : ''
                                                        }
                                                        {!item.isParent && item.status === 'checked' 
                                                            ? <span><Icon name="check" className="color-blue" /> <small>Comprobado</small></span>
                                                            : ''
                                                        }
                                                    </span>
                                                )} />
                                                {!this.state.currentHotel
    		                                      ? <Column title="Hotel" key="hotel" render={(item) => (
    		                                        	<span>{item.hotel ? item.hotel.name : '-'}</span>
    		                                        )} />
                                                    : ''
                                                }
                                                {this.props.app.user && this.props.app.user.type !== 'recepcionista'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
		                                        <Column title="Pago" key="payment" render={(item) => (
    		                                        <span>{item.payment ? item.payment.name : '-'}</span>
		                                        )}/>
		                                        <Column title="Ingreso" key="amount_income" render={(item) => (
                                                    <span>
                                                        {item.isParent
                                                            ? <Currency quantity={item.amount_income_total ? item.amount_income_total : 0} currency="USD" />
                                                            : <span>
                                                                {item.amount_income
                                                                    ? <Currency quantity={item.amount_income} currency="USD" />
                                                                    : '-'
                                                                }
                                                            </span>
                                                        }
                                                    </span>
                                                )}/>
                                                <Column title="Egreso" key="amount_expense" render={(item) => (
                                                    <span>
                                                        {item.isParent
                                                            ? <Currency quantity={item.amount_expense_total ? item.amount_expense_total : 0} currency="USD" />
                                                            : <span>
                                                                {item.amount_expense
                                                                    ? <Currency quantity={item.amount_expense} currency="USD" />
                                                                    : '-'
                                                                }
                                                            </span>
                                                        }
                                                    </span>
                                                )}/>
                                                <Column title="Asignado a" key="chargedTo" render={(item) => (
                                                    <span style={{textTransform: 'capitalize'}}>{item.chargedTo ? item.chargedTo : '-'}</span>
                                                )} />
                                                <Column title="Notas" key="notes" dataIndex="notes"/>
                                                <Column title="Fecha Actualización" key="updatedAt" width={135} render={(item) => (
                                                    <span>{item.updatedAt ? moment(item.updatedAt).format('DD/MM/YYYY') : ''}</span>
                                                )} />
		                                        <Column title="Acciones" key="action" width={120}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            {!item.isParent
                                                                ? <ButtonGroup>
                                                                    <Tooltip placement="bottom" title="Editar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                        </Button>
                                                                    </Tooltip>

                                                                    {(!item.status || item.status === 'pending') && this.props.app.user && this.props.app.user.type === 'administrador'
                                                                        ? <Tooltip placement="bottom" title="Pagado">
                                                                            <Button>
                                                                                <Link onClick={() => { this.incomePaidout(item) }}><Icon name="check" /></Link>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    <Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </ButtonGroup>
                                                                : ''
                                                            }
                                                        </span>
                                                    )}
                                                />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>

                <Modal
                    width={700}
                    visible={this.state.NewIncomeVisible}
                    title="Pago"
                    onCancel={this.hideModalNewIncome.bind(this)}
                    footer={[]} 
                >
                    {this.state.NewIncomeVisible
                        ? <PaymentNew {...this.state.newIncomeProps} />
                        : ''
                    }
                </Modal>
	        </div>
	    )
	}
}

export default connect(({income, app}) => ({income, app}))(Form.create()(Payment))


// WEBPACK FOOTER //
// ./src/components/incomes/payments.js